import React from "react";
import "./styles/Home.css";
import { Link } from "react-router-dom";

import image1 from "../medias/1.jpg";
import image2 from "../medias/2.jpg";
import image3 from "../medias/3.jpg";
import image5 from "../medias/5.jpg";
import image6 from "../medias/6.jpg";

const Home = () => {
  return (
    <main className="home-container">
      <section className="home-hero">
        <div className="home-hero-content">
          <h1>Entreprise VRD à Toulouse</h1>
          <p>
            Spécialisé en géothermie. Intervention rapide, travail rigoureux, devis gratuit sous 24h.
          </p>
          <Link to="/contact" className="home-cta">
            Demander un devis
          </Link>
        </div>
      </section>

      <section className="home-about-preview">
        <img
          src={image1}
          alt="Portrait de l'artisan électricien en travaux publics"
          className="home-about-img"
        />
        <h2>Société de confiance à votre service</h2>
        <p>
          Avec plus de 10 ans d'expérience dans les travaux publics et la géothermie, nous nous engageons à garantir sécurité, fiabilité et conformité sur chacun de vos projets.
        </p>
        <Link to="/about" className="home-link">
          En savoir plus sur mon parcours →
        </Link>
      </section>

      <section className="home-services">
        <h2>Mes services principaux</h2>
        <div className="home-services-list">
          <div className="home-service">
            <img src={image3} alt="Pose de PEHD" className="home-service-img" />
            <h3>Pose de PEHD + soudure</h3>
            <p>Réseaux PEHD soudés haute résistance pour l'alimentation en énergie, chauffage ou fluides techniques. Travaux conformes aux normes de sécurité et durabilité.</p>
          </div>
          <div className="home-service">
            <img src={image6} alt="Pose et réglage de collecteur géothermie" className="home-service-img" />
            <h3>Pose et réglage de collecteur géothermie</h3>
            <p>Mise en place de collecteurs géothermiques optimisés pour un rendement thermique maximal. Réglages adaptés aux besoins du site et à la configuration du terrain.</p>
          </div>
          <div className="home-service">
            <img src={image2} alt="Réalisation de tranchée sous espace vert ou voirie" className="home-service-img" />
            <h3>Réalisation de tranchée sous espace vert ou voirie</h3>
            <p>Creusement de tranchées techniques en milieux sensibles (espaces verts, voiries), avec respect des autorisations administratives et des contraintes environnementales.</p>
          </div>
        </div>
        <Link to="/services" className="home-link">
          Voir tous les services →
        </Link>
      </section>

      <section className="home-area">
        <h2>Zone d'intervention</h2>
        <p>
          Basé à Toulouse, j'interviens partout en Occitanie et en Nouvelle-Aquitaine : chantiers publics, privés, logements neufs, rénovations, sites industriels.
        </p>
        <div className="home-image">
          <img
            src={image5}
            alt="Carte d'intervention autour de Toulouse"
            className="home-area-img"
          />
          <img
            src={image2}
            alt="Carte d'intervention autour de Toulouse"
            className="home-area-img"
          />
        </div>
      </section>

      <section className="home-guarantees">
        <h2>Vos travaux en toute confiance</h2>
        <ul>
          <li>✅ Assurance décennale professionnelle</li>
          <li>✅ Délais respectés contractuellement</li>
          <li>✅ Matériel certifié et conforme</li>
          <li>✅ Opérateur formé CACES</li>
          <li>✅ Qualification en électrosoudure</li>
        </ul>
      </section>

      <section className="home-final-cta">
        <h2>Vous avez un projet de chantier ?</h2>
        <p>Contactez-nous dès aujourd'hui pour un devis clair, gratuit et rapide.</p>
        <Link to="/contact" className="home-cta">
          Contactez-nous
        </Link>
      </section>
    </main>
  );
};

export default Home;
